import { RenderReact, type Root } from '@doist/content-system';
import cn from 'clsx';
import { getComponents } from 'services/content-system/blog-post/components';
import css from '../blog-post.module.css';
import type { HTMLAttributes } from 'react';

/** Render a Contentful RichText component. */
export type CTFRichTextProps = {
  document: Root;
  callout?: React.ReactNode;
  blogTranslation?: (text: string) => string;
} & HTMLAttributes<HTMLDivElement>;
export function CTFRichText({
  document,
  callout,
  className,
  blogTranslation = string => string,
  ...rest
}: CTFRichTextProps) {
  return <section className={cn(css.content, className)} {...rest} data-sentry-component="CTFRichText" data-sentry-source-file="ctf-rich-text.tsx">
            {callout}
            <RenderReact content={document} components={getComponents(blogTranslation)} data-sentry-element="RenderReact" data-sentry-source-file="ctf-rich-text.tsx" />
        </section>;
}